<template>
  <div class="container">
    <!-- <div class="title-box">
      <div class="return" @click="handleBack">
        <img src="@assets/images/return-lg.png" class="lg" />
      </div>
      <div class="title1">发票</div>
      <div class="return" style="visibility: hidden;">
        <img src="@assets/images/return-lg.png" class="lg" />
      </div>
    </div>
    <div style="height: 0.96rem;"></div> -->
    <div class="tips">
      <img style="width:24px;height:24px;" src="@assets/images/tips.png" />
      <div class="content">
        发票由商家提供，订单确认收货后10个工作日内开票，如紧急请联系商家客服协助！
      </div>
    </div>
    <div class="operater">
      <div class="item">
        <div class="in-1">开票金额</div>
        <div class="in-2">{{ payPrice }}</div>
      </div>
      <div class="item bor">
        <div class="in-1">发票类型</div>
        <div class="item-t">电子普通发票</div>
      </div>
      <div class="item">
        <div class="in-1">发票抬头</div>
        <div>
          <span @click="handleType(1)" class="t" :class="{ itemCheck: type == 1 }">个人</span>
          <span @click="handleType(2)" class="t" :class="{ itemCheck: type == 2 }">企业</span>
        </div>
      </div>
    </div>

    <!-- 个人 -->
    <div class="content-g" v-if="type == '1'">
      <div class="item">
        <div class="title">抬头名称<span class="ck">*</span></div>
        <input type="text" placeholder="个人/非企业性单位" v-model="header" />
      </div>
      <div class="item">
        <div class="title">手机号码</div>
        <input type="tel" max="11" placeholder="请输入手机号" v-model="phone" />
      </div>
      <div class="item">
        <div class="title">邮箱地址<span class="ck">*</span></div>
        <input type="email" placeholder="用于接收发票的邮箱" v-model="email" />
      </div>
    </div>

    <!-- 企业 -->
    <div class="content-g" v-else>
      <div class="item">
        <div class="title">抬头名称<span class="ck">*</span></div>
        <input type="text" placeholder="请输入企业名称或代开代码" v-model="header" />
      </div>
      <div class="item">
        <div class="title">税号<span class="ck">*</span></div>
        <input type="text" placeholder="请输入6-20位企业税号" v-model="taxId" />
      </div>
      <div class="item">
        <div class="title">手机号码</div>
        <input type="tel" max="11" placeholder="请输入手机号" v-model="phone" />
      </div>
      <div class="item">
        <div class="title">邮箱地址<span class="ck">*</span></div>
        <input type="text" placeholder="用于接收发票的邮箱" v-model="email" />
      </div>
    </div>
    <!-- 备注 -->
    <div class="content-g">
      <div class="item beizhu">
        <div class="title" style="margin-top: 4px;">备注</div>
        <textarea class="text" placeholder="添加备注给商家" v-model="notes"></textarea>
      </div>
    </div>
    <div class="returnBnt" @click="submit">提交</div>
  </div>
</template>

<script>
import { postInvoice } from "@api/user";
import attrs, { required, chs_phone, email } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { orderDetail } from "@api/order";

export default {
  name: "Invoice",
  data: function() {
    return {
      type: 1, //发票类型 1-个人  2-企业
      order_id: "",
      payPrice: "0",
      header: "",
      taxId: "",
      phone: "",
      email: "",
      notes: "",
    };
  },
  mounted: function() {
    this.getOrderInfo();
  },

  methods: {
    handleBack: function() {
      this.$router.back();
    },
    getOrderInfo() {
      let orderid = this.$route.params.id;
      orderDetail(orderid)
        .then((res) => {
          this.payPrice = res.data.pay_price;
          this.order_id = res.data.order_id;
        })
        .catch((err) => {
          this.$dialog.error(err.msg);
        });
    },
    handleType(type) {
      this.type = type;
    },
    async submit() {
      let header = this.header,
        taxId = this.taxId,
        phone = this.phone,
        email = this.email;
      if (this.type == 2) {
        try {
          await this.$validator({
            taxId: [required("请填写税号"), attrs.range([6, 20], attrs.range.message("税号"))],
          }).validate({ taxId });
        } catch (e) {
          return validatorDefaultCatch(e);
        }
      }
      try {
        await this.$validator({
          header: [required(required.message("抬头名称"))],
          phone: [chs_phone(chs_phone.message())],
          email: [required(required.message("邮箱"))],
        }).validate({ header, phone, email });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      try {
        let that = this,
          data = {
            type: that.type,
            order_id: that.order_id,
            payPrice: that.payPrice,
            header: that.header,
            taxId: that.taxId,
            phone: that.phone,
            email: that.email,
            notes: that.notes,
          };
        postInvoice(data)
          .then(function() {
            that.$dialog.toast({ mes: "提交成功，请注意查收！" });
            setTimeout(() => {
              that.$router.go(-1);
            }, 1000);
          })
          .catch((err) => {
            that.$dialog.error(err.msg);
          });
      } catch (e) {
        this.$dialog.error(e.msg);
      }
    },
  },
};
</script>

<style lang="scss">
.container {
}

.tips {
  display: flex;
  align-items: center;
  padding: 12px;
  .content {
    font-size: 14px;
    color: #b1b1b1;
    margin-left: 8px;
  }
}

.operater {
  background: white;
  padding: 0 12px;
  .item {
    display: flex;
    align-items: center;
    padding: 14px 0;
    .item-t {
      font-size: 14px;
      color: white;
      background: red;
      padding: 8px 12px;
      border-radius: 25px;
      line-height: 1;
    }
    .t {
      padding: 8px 20px;
      margin-right: 24px;
      background: none;
      border: #ececec 1px solid;
      color: black;
      border-radius: 25px;
    }
    .itemCheck {
      pointer-events: auto !important;
      font-size: 14px;
      color: white;
      background: red;
      padding: 8px 20px;
      border-radius: 25px;
      line-height: 1;
      border: none;
    }
    .in-1 {
      margin-right: 50px;
    }
  }
  .bor {
    border-top: #ececec 1px solid;
    border-bottom: #ececec 1px solid;
  }
}

.content-g {
  background: white;
  padding: 0 12px;
  margin-top: 20px;
  .title {
    width: 100px;
  }
  .ck {
    color: red;
    margin-left: 5px;
  }
  .item {
    display: flex;
    align-items: center;
    padding: 14px 0;
  }
  .item:not(:last-child) {
    border-bottom: #ececec 1px solid;
  }
  .beizhu {
    display: flex;
    align-items: flex-start;
  }
  .text {
    width: 100%;
    height: 100px;
    background: #f5f5f5;
    border-radius: 10px;
    padding: 5px 10px;
  }
}

.returnBnt {
  width: 200px;
  margin: 0 auto;
  margin-top: 40px;
  border-radius: 25px;
  text-align: center;
  padding: 10px;
  background: red;
  color: white;
}
.returnBnt:active {
  opacity: 0.8;
}

.title-box {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 0.96rem;
  display: flex;
  justify-content: space-between; /* 左右贴边，中间自适应 */
  align-items: center; /* 垂直居中（可选） */
  background: white;
  border-bottom: #f0f0f0 1px solid;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
  .title-box:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* 悬停时阴影变大 */
  }

  .title {
    margin: 0 auto; /* 关键：让中间元素自动居中 */
    letter-spacing: 1px;
  }
  .return {
    display: flex;
    flex-direction: row;
    align-items: center;
    .lg {
      width: 24px;
      height: 24px;
    }
    .close {
      font-size: 15px;
      margin-left: 10px;
    }
  }
}
</style>
